<template>
  <Transition
    enter-from-class="-translate-y-full"
    leave-to-class="-translate-y-full"
    enter-active-class="duration-700 transition-transform"
    leave-active-class="duration-700 transition-transform"
  >
    <div
      class="fixed top-0 left-0 z-20 min-h-max w-full"
      v-show="displayed"
    >
      <div class="container relative px-4">
        <slot></slot>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'GenericBanner',
  props: {
    displayed: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
